$(document).ready(function () {
    $('.close-btn').click(function () {
        $(this).parent().hide();
    });

    $('.btn-copy').click(function () {
        copyText($(this).siblings('span'));

        if (!$(this).is('svg')) {
            $(this).text($(this).data('after'));
        }
    });

    $('#editGridForm').keydown(function (event) {
        if (event.keyCode === 13) {
            event.preventDefault();
            return false;
        }
    });
});

function copyText(el) {
    let $tmp = $("<textarea>");
    $("body").append($tmp);
    $tmp.val($(el).text()).select();
    document.execCommand("copy");
    $tmp.remove();
}
